import {convertCoordinates} from '@/api/util-coordinates';

class ServiceAreaApiResponseModel {
  // #region Props

  // #endregion
  constructor(
    {
      id,
      name,
      highway,
      route,
      km,
      cx,
      cy,
      fuelStation,
      cafe,
      restaurant,
      phone,
      shop,
      hotel,
      // visible,
    },
    locale = 'es-ES',
  ) {
    const kmsNumberFormat = new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 0,
    });
    return {
      id,
      name,
      highway,
      route,
      km: kmsNumberFormat.format(km),
      coordinates: convertCoordinates(cx, cy),
      fuelStation: fuelStation > 0,
      cafe: cafe > 0,
      restaurant: restaurant > 0,
      phone: phone > 0,
      shop: shop > 0,
      hotel: hotel > 0,
      visible: false,
    };
  }
}

export default ServiceAreaApiResponseModel;
